import React, { useState, useEffect } from 'react';
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Divider
} from '@mui/material';

const CorrectionEditorModal = ({ open, onClose, event, actionType }) => {
    const [payload, setPayload] = useState({ ...event });
    const [rawJson, setRawJson] = useState(JSON.stringify(event, null, 2));
    const [jsonError, setJsonError] = useState('');
    const [reason, setReason] = useState('');
    const [agentId, setAgentId] = useState(event?.agent?._id || '');

    useEffect(() => {
        setPayload({ ...event });
        setRawJson(JSON.stringify(event, null, 2));
        setJsonError('');
        setReason('');
        setAgentId(event?.agent?._id || '');
    }, [event, open]);

    const handleChange = (field) => (e) => {
        const value = e.target.value;
        const updated = { ...payload, [field]: value };
        setPayload(updated);
        setRawJson(JSON.stringify(updated, null, 2));
    };

    const handleJsonChange = (e) => {
        const value = e.target.value;
        setRawJson(value);

        try {
            const parsed = JSON.parse(value);
            setPayload(parsed);
            setJsonError('');
        } catch (err) {
            setJsonError('Invalid JSON');
        }
    };

    const handleSubmit = async () => {
        const data = {
            eventId: event._id,
            actionType,
            originalPayload: event,
            editedPayload: payload,
            reason,
            agent: agentId,
            editedBy: 'mockUserId_123' // replace with actual UID
        };

        console.log('Submitting Correction:', data);

        // TODO: send POST to /api/human-corrections
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Paper
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '95vw',
                    maxWidth: 900,
                    maxHeight: '95vh',
                    overflowY: 'auto',
                    p: 4,
                    bgcolor: '#202020',
                    color: '#fff',
                    border: '1px solid #333',
                    borderRadius: 2
                }}
            >
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {actionType === 'approve' ? 'Approve & Modify Payload' : 'Execute & Modify Payload'}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
                    {Object.entries(payload).map(([key, value]) => (
                        <TextField
                            key={key}
                            label={key}
                            value={value}
                            onChange={(e) => handleChange(key)(e)}
                            fullWidth
                            sx={{ my: 1, backgroundColor: '#1a1a1a' }}
                            InputLabelProps={{ sx: { color: '#ccc' } }}
                            InputProps={{ sx: { color: '#fff' } }}
                        />
                    ))}
                </Box>


                <Divider sx={{ borderColor: '#444', mb: 3 }} />

                <Typography variant="subtitle2" sx={{ color: '#ccc', mb: 1 }}>
                    Raw Payload
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    minRows={8}
                    maxRows={20}
                    value={rawJson}
                    onChange={handleJsonChange}
                    error={!!jsonError}
                    helperText={jsonError || 'Edit full payload directly. Form will sync if valid JSON.'}
                    InputProps={{
                        sx: {
                            fontFamily: 'monospace',
                            color: '#fff'
                        }
                    }}
                    sx={{ backgroundColor: '#1a1a1a' }}
                />

                <Divider sx={{ borderColor: '#444', my: 3 }} />

                <Typography variant="subtitle2" sx={{ color: '#ccc', mb: 1 }}>
                    Add notes - Correction Reason (optional)
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    placeholder="E.g. Coach not available — reassigned to backup."
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    sx={{ backgroundColor: '#1a1a1a', color: '#fff' }}
                    InputProps={{ sx: { color: '#fff' } }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                    <Button variant="outlined" onClick={onClose}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={handleSubmit}
                        disabled={!!jsonError}
                    >
                        Submit {actionType === 'approve' ? 'Approval' : 'Execution'}
                    </Button>
                </Box>
            </Paper>
        </Modal>
    );
};

export default CorrectionEditorModal;
